(ns frontend.analytics
  (:require [frontend.db :as db]
            [frontend.intercom :as intercom]))

(defn put-on-hold! [with-notification?]
  (intercom/event (if with-notification?
                    "Hold-and-notify"
                    "Hold-no-notification")))

(defn pass! [with-notification?]
  (intercom/event (if with-notification?
                    "Pass-and-notify"
                    "Pass-no-notification")))

(defn event [event-key]
  (when event-key
    (intercom/event event-key)))
